import { useGraphql } from 'utils/hooks/useGraphql';
import { fetchRootListFolderQuery } from 'api/queries';

export const ROOT_FOLDER_ID = 0;

/**
 * This is temporary until we can get this off project settings
 * https://iterable.slab.com/posts/7-1-21-treating-null-as-folder-id-for-root-folders-8tre2dp6#proposed-options
 */
export const useRootListFolderId = (): number => {
  const { data } = useGraphql(fetchRootListFolderQuery, {
    variables: {
      folderId: null,
    },
  });

  return data?.listFolder?.id || ROOT_FOLDER_ID;
};
